/**
 * @module FE-CU04_パスワード初期化画面_ユーザーID入力
 */
import Header from '../../components/header/Header.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import { checkMailAddressFormat } from '../../utile/validation';

const PAGE_ID = 'FE-CU04';

export default {
  name: 'PasswordInitUserIdEntry',
  components: {
    Header,
    PcPageTitle,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t(
        '$vuetify.FECU04パスワード初期化画面ユーザーID入力.パスワード初期化ユーザーID'
      ),
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU04パスワード初期化画面ユーザーID入力.C0001'
      ),
      userId: '',
      confirmUserId: '',
      valid: false,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    userIdRules() {
      if (this.userId === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU04パスワード初期化画面ユーザーID入力.E0001'
          ),
        ];
      }
      if (typeof this.userId === 'undefined') {
        return [true];
      } else {
        return [
          checkMailAddressFormat(this.userId) ||
            this.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU04パスワード初期化画面ユーザーID入力.E0008'
            ),
        ];
      }
    },
    confirmUserIdRules() {
      if (this.confirmUserId === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU04パスワード初期化画面ユーザーID入力.E0004'
          ),
        ];
      }
      if (this.userId !== this.confirmUserId) {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU04パスワード初期化画面ユーザーID入力.E0007'
          ),
        ];
      }
      if (typeof this.confirmUserId === 'undefined') {
        return [true];
      } else {
        return [
          checkMailAddressFormat(this.confirmUserId) ||
            this.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU04パスワード初期化画面ユーザーID入力.E0009'
            ),
        ];
      }
    },
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t(
          '$vuetify.FECU04パスワード初期化画面ユーザーID入力.パスワード初期化ユーザーID'
        ),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU04パスワード初期化画面ユーザーID入力.C0001'
        ),
      };
    },
    // メールを送信ボタン活性制御
    disabled() {
      if (
        this.userId !== '' &&
        this.confirmUserId !== '' &&
        this.userId === this.confirmUserId &&
        this.valid
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * メールを送信ボタン押下処理
     */
    submit() {
      if (this.$refs.form.validate()) {
        this.APP_CU0401();
      }
    },
    /**
     * APP_CU0401 ワンタイムURL発行
     * @returns {object} レスポンス
     */
    APP_CU0401: async function () {
      this.$_setLoading(true);

      // 正常系を確認したい場合は下記のコメントを解除する
      // let param = "post"; // 検証用
      let param = '/api/passwordInitUserIdEntry/oneTimeUrlIssuing'; // 本番用

      let queries = {
        userId: this.userId,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            // Thanks画面に遷移する。
            this.$store.commit('setThanksType', {
              fromPageInfo: { page: 4 },
              displayType: 1,
            });
            this.$router.push('thanks');
          },
          (error) => {
            if (error.message.includes('400')) {
              this.callSaveErrorDialog();
            } else {
              // 異常系の処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * エラーダイアログ
     */
    async callSaveErrorDialog() {
      await this.$errorDialog(
        '$vuetify.メッセージ一覧.FECU04パスワード初期化画面ユーザーID入力.E0010'
      );
    },
  },
  mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);
    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);
    //初期通信完了後に画面を表示
    this.isShowPage = true;
  },
};
